export const animate = (image) => {
  let frame = 1;
  let positionX = 1;
  const totalFrames = 49;

  const imageWidth = image.getBoundingClientRect().width;

  const interval = setInterval(() => {
    if (frame === totalFrames) clearInterval(interval);

    frame++;
    positionX -= imageWidth;
    image.style.setProperty("--bg-position", `${positionX}px 0px`);
  }, 60);
};

export const getCookieValue = (name) => {
  const regex = new RegExp(`(^| )${name}=([^;]+)`);
  const match = document.cookie.match(regex);

  if (match) {
    return match[2];
  }
};
